
const routes = [
  { path: '/about', component: about }
];
<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/LOGOBLANCO.jpg')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />

      <base-title
        size="body-1"
        space="4"
        title="COMERCIAL C&D GROUP LIMITADA"
        weight="regular"
      />
      <base-body>
      Aportamos soluciones concretas a la demanda general del mercado. Asesoramos y aportamos soluciones pensando en las necesidades de los clientes.
      </base-body>
      <base-btn
        class="mb-12"
        color="white"
        outlined
        to="/about"
      >Más Información
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Dirección',
          text: 'FARO SAN PEDRO #2006, Lampa , Metropolitana de Santiago Chile',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '+56 9 6741 5474<br>+ 56 9 56291289',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'contacto@cydgroup.com<br>gcampos@cydgroup.com',
        },
      ],
    }),
  }
</script>
